import { userUserStore } from "../store/useUserStore";

export const useCan = (permission) => {
  const useStore = userUserStore();
  const { permissions } = useStore.user.permissions;

  if (!permission) return true; // item sem permission e publico
  return permissions.includes(permission);
};
